module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/components/Leaderboard/images/sparkles.c64cd10c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/components/Leaderboard/images/sparkles.png
// module id = 2815
// module chunks = 11